<div class="formulabar-component" *ngIf="!showNewFbar">
  <span class="fx" *ngIf="showFx">fx</span>
  <div id="formulabar" [ngClass]="openedForAddIn ? 'excel-formulabar' : ''">
    <div
      class="fbar-container"
      [ngClass]="
        fbarExpanded ? 'expanded-fbar-container' : 'collapsed-fbar-container'
      "
      [ngStyle]="
        comparativeAnalysisBorderedFormulaBar
          ? comparativeAnalysisShortFormulaBar
            ? { border: '1px solid #BCC2CC', width: '42vw' }
            : { border: '1px solid #BCC2CC', width: '60vw' }
          : {}
      "
    >
      <!-- If no expression_error flag-->
      <div *ngIf="statusError">
        <span class="zero"
          ><b>{{ errorMessage }}</b></span
        >
      </div>
      <nz-spin *ngIf="loading" nzSimple [nzSize]="'small'"></nz-spin>
      <div
        class="tree-poc"
        *ngIf="!loading"
        [ngClass]="
          openedForAddIn && !statusError
            ? 'all-border'
            : fbarExpanded
              ? 'expanded-fbar'
              : ''
        "
      >
        <nz-tree
          #nzTreeComponent
          [nzData]="nodes"
          [nzBlockNode]="true"
          [nzTreeTemplate]="formulaTreeTemplate"
          (nzClick)="onFbarClick($event)"
          (nzExpandChange)="onFbarExpand($event)"
          [nzExpandedIcon]="doubleArrowExpandIcon"
          [nzExpandedKeys]="defaultExpandedKeys"
        ></nz-tree>

        <!-- Stats Section -->
        <div
          *ngIf="fbarExpanded && formulabarData.cut !== 'SAR'"
          class="fbar-stats-section"
        >
          <!-- Line name section for fuzy line item Fuzzy design -->
          <div nz-row nzType="flex" nzJustify="start">
            <b>
              <!-- Fuzzy stats -->
              <span *ngIf="formulabarData.is_fuzzy === true">{{
                formulabarData.fuzzy_line_name
              }}</span>
              <span
                *ngIf="
                  formulabarData.is_fuzzy && formulabarData.display_magnitude
                "
                >({{ formulabarData.display_magnitude }})</span
              >
              <span *ngIf="formulabarData.is_fuzzy" class="fuzzy-color">
                &mdash; {{ formulabarData.name }}
              </span>
              <!-- Fuzzy stats -->

              <span *ngIf="!formulabarData.is_fuzzy"
                >{{ formulabarData.name
                }}<span *ngIf="formulabarData.display_magnitude">(</span
                >{{ formulabarData.display_magnitude
                }}<span *ngIf="formulabarData.display_magnitude">)</span></span
              >
              <ng-container
                *ngIf="
                  formulabarData.source ||
                  formulabarData.period ||
                  historicalRevision ||
                  formulabarData.growthtype ||
                  formulabarData.calculation_method
                "
              >
                ({{ formulabarData.source
                }}{{ formulabarData.source && formulabarData.period ? ", " : ""
                }}{{ formulabarData.period
                }}<span *ngIf="formulabarData.forecast">E</span>
                {{
                  formulabarData.period &&
                  (formulabarData.growthtype || historicalRevision)
                    ? ", "
                    : ""
                }}
                <span
                  *ngIf="
                    historicalRevision !== undefined &&
                    historicalRevision !== ''
                  "
                  >{{ historicalRevision }}
                  {{
                    historicalRevision && formulabarData.growthtype ? ", " : ""
                  }}</span
                >
                {{ formulabarData.growthtype }}
                {{
                  formulabarData.growthtype && formulabarData.calculation_method
                    ? ", "
                    : ""
                }}
                {{ formulabarData.calculation_method }})
              </ng-container>
            </b>
          </div>

          <!-- stats section for valuation -->
          <div
            *ngIf="
              (formulabarData.stats | keyvalue)?.length &&
              formulabarData.stats.show_brokers_only
            "
            class="stats-line-heading"
          >
            <span *ngIf="formulabarData.stats.broker_count !== undefined">
              <b>Broker Count</b> =
              {{ formulabarData.stats.broker_count }}
            </span>
          </div>

          <!-- full stats section for source other than Va Actuals -->
          <div
            *ngIf="
              (formulabarData.stats | keyvalue)?.length &&
              !formulabarData.stats.show_brokers_only &&
              (formulabarData.period === 'LTM' ||
                formulabarData.period === 'NTM' ||
                formulabarData.period === 'STM' ||
                (formulabarData.source &&
                  (formulabarData.source | lowercase) !== 'va actuals'))
            "
            class="stats-line-heading"
          >
            <div nz-row nzType="flex" nzJustify="start" nzGutter="20">
              <div nz-col nzSpan="8">
                <span *ngIf="formulabarData.stats.mean !== undefined"
                  ><b>Mean</b> =
                  <app-value-renderer
                    [value]="formulabarData.stats.mean"
                    [precision]="2"
                  ></app-value-renderer
                ></span>
                <span *ngIf="formulabarData.stats.mean === undefined"
                  ><b>Mean</b> = NA</span
                ><br />
                <span *ngIf="formulabarData.stats.broker_count !== undefined"
                  ><b>Broker Count</b> =
                  {{ formulabarData.stats.broker_count }}</span
                >
                <span *ngIf="formulabarData.stats.broker_count === undefined"
                  ><b>Broker Count</b> = NA</span
                ><br />
                <span *ngIf="formulabarData.stats.median !== undefined"
                  ><b>Median</b> =
                  <app-value-renderer
                    [value]="formulabarData.stats.median"
                    [precision]="2"
                  ></app-value-renderer
                ></span>
                <span *ngIf="formulabarData.stats.median === undefined"
                  ><b>Median</b> = NA</span
                ><br />
                <span
                  *ngIf="formulabarData.stats.consensus_ex_min !== undefined"
                >
                  <span
                    *ngIf="
                      formulabarData.source.toLowerCase() !== 'consensus+' &&
                      formulabarData.rpsource.toLowerCase() !== 'consensus+'
                    "
                  >
                    <b>ConsensusExMin</b> =
                  </span>
                  <span
                    *ngIf="
                      formulabarData.source.toLowerCase() === 'consensus+' ||
                      formulabarData.rpsource.toLowerCase() === 'consensus+'
                    "
                  >
                    <b>Consensus+ExMin</b> =
                  </span>
                  <app-value-renderer
                    [value]="formulabarData.stats.consensus_ex_min"
                    [precision]="2"
                  ></app-value-renderer
                ></span>
                <span
                  *ngIf="formulabarData.stats.consensus_ex_min === undefined"
                >
                  <b>ConsensusExMin</b> = NA</span
                ><br />
              </div>

              <div nz-col nzSpan="8">
                <span *ngIf="formulabarData.stats.mn !== undefined"
                  ><b>Min</b> =
                  <app-value-renderer
                    [value]="formulabarData.stats.mn.v"
                    [precision]="2"
                  ></app-value-renderer
                  ><span
                    *ngIf="
                      brokerCountForSellSide === 0 ||
                      formulabarData.stats.mn.sName
                    "
                  >
                    [</span
                  >{{ formulabarData.stats.mn.sName
                  }}<span
                    *ngIf="
                      brokerCountForSellSide === 0 ||
                      formulabarData.stats.mn.sName
                    "
                    >]</span
                  ></span
                >
                <span *ngIf="formulabarData.stats.mn === undefined"
                  ><b>Min</b> = NA </span
                ><br />
                <span
                  *ngIf="
                    formulabarData.stats &&
                    formulabarData.stats.broker_count !== undefined &&
                    formulabarData.stats.d !== undefined
                  "
                  ><b>Standard Deviation</b> =
                  <app-value-renderer
                    [value]="formulabarData.stats.d"
                    [precision]="2"
                  ></app-value-renderer
                ></span>
                <span
                  *ngIf="
                    formulabarData.stats &&
                    (formulabarData.stats.broker_count === undefined ||
                      formulabarData.stats.d === undefined)
                  "
                  ><b>Standard Deviation</b> = NA</span
                ><br />
                <span
                  *ngIf="
                    formulabarData.stats &&
                    formulabarData.stats.range !== undefined
                  "
                  ><b>Range</b> =
                  <app-value-renderer
                    [value]="formulabarData.stats.range"
                    [precision]="2"
                  ></app-value-renderer
                ></span>
                <span
                  *ngIf="
                    formulabarData.stats &&
                    formulabarData.stats.range === undefined
                  "
                  ><b>Range</b> = NA</span
                ><br />
                <ng-container
                  [ngTemplateOutlet]="consensusExMinExMax"
                  [ngTemplateOutletContext]="{ formulabarData: formulabarData }"
                >
                </ng-container>
                <br />
              </div>

              <div nz-col nzSpan="8">
                <span *ngIf="formulabarData.stats.mx !== undefined"
                  ><b>Max</b> =
                  <app-value-renderer
                    [value]="formulabarData.stats.mx.v"
                    [precision]="2"
                  ></app-value-renderer
                  ><span
                    *ngIf="
                      brokerCountForSellSide === 0 ||
                      formulabarData.stats.mx.sName
                    "
                  >
                    [</span
                  >{{ formulabarData.stats.mx.sName
                  }}<span
                    *ngIf="
                      brokerCountForSellSide === 0 ||
                      formulabarData.stats.mx.sName
                    "
                    >]</span
                  ></span
                >
                <span *ngIf="formulabarData.stats.mx === undefined"
                  ><b>Max</b> = NA</span
                ><br />
                <span *ngIf="formulabarData.stats.cv !== undefined"
                  ><b>CV</b> =
                  <app-value-renderer
                    [value]="formulabarData.stats.cv"
                    [precision]="2"
                  ></app-value-renderer>
                  %</span
                >
                <span *ngIf="formulabarData.stats.cv === undefined"
                  ><b>CV</b> = NA</span
                ><br />
                <span
                  *ngIf="formulabarData.stats.consensus_ex_max !== undefined"
                >
                  <span
                    *ngIf="
                      formulabarData.source.toLowerCase() !== 'consensus+' &&
                      formulabarData.rpsource.toLowerCase() !== 'consensus+'
                    "
                  >
                    <b>ConsensusExMax</b> =
                  </span>
                  <span
                    *ngIf="
                      formulabarData.source.toLowerCase() === 'consensus+' ||
                      formulabarData.rpsource.toLowerCase() === 'consensus+'
                    "
                  >
                    <b>Consensus+ExMax</b> =
                  </span>
                  <app-value-renderer
                    [value]="formulabarData.stats.consensus_ex_max"
                    [precision]="2"
                  ></app-value-renderer
                ></span>
                <span
                  *ngIf="formulabarData.stats.consensus_ex_max === undefined"
                >
                  <b>ConsensusExMax</b> = NA</span
                ><br />
              </div>
            </div>
          </div>

          <!-- Stats specifically for Va Actuals -->
          <div
            *ngIf="
              (formulabarData.stats | keyvalue)?.length &&
              formulabarData.source &&
              (formulabarData.source | lowercase) === 'va actuals'
            "
            class="stats-line-heading"
          >
            <!-- VA Actuals stats for Mode - Mode, REVISED_MODE and RESTATED -->
            <div
              nz-row
              nzType="flex"
              nzJustify="start"
              nzGutter="20"
              *ngIf="
                formulabarData.Mode &&
                (formulabarData.Mode.toLowerCase() === 'mode' ||
                  formulabarData.Mode.toLowerCase() === 'revised_mode' ||
                  formulabarData.Mode.toLowerCase() === 'restated')
              "
            >
              <div nz-col nzSpan="8">
                <span *ngIf="formulabarData.stats.broker_count !== undefined"
                  ><b>Number of brokers in mode</b> =
                  {{ formulabarData.stats.broker_count }}</span
                ><br />
              </div>
              <div nz-col nzSpan="8">
                <span *ngIf="formulabarData.stats.consensus_count !== undefined"
                  ><b>Total brokers</b> =
                  {{ formulabarData.stats.consensus_count }}</span
                ><br />
              </div>
              <div nz-col nzSpan="8">
                <span *ngIf="formulabarData.stats.filing_value !== undefined"
                  ><b>Company reported actual</b> =
                  <span *ngIf="formulabarData.stats.filing_value !== 'NA'">
                    <app-value-renderer
                      [value]="formulabarData.stats.filing_value"
                      [precision]="2"
                    ></app-value-renderer>
                  </span>
                  <span *ngIf="formulabarData.stats.filing_value === 'NA'">
                    NA
                  </span>
                </span>
                <br />
              </div>
            </div>
            <!-- VA Actuals stats for Mode - Consensus, which shows as AVG in the fbar expression-->
            <div
              nz-row
              nzType="flex"
              nzJustify="start"
              nzGutter="20"
              *ngIf="
                formulabarData.Mode &&
                formulabarData.Mode.toLowerCase() === 'consensus'
              "
            >
              <!-- <div nz-row nzType="flex" nzJustify="start" nzGutter="20"> -->
              <div nz-col nzSpan="8">
                <span *ngIf="formulabarData.stats.mean !== undefined"
                  ><b>Mean</b> =
                  <app-value-renderer
                    [value]="formulabarData.stats.mean"
                    [precision]="2"
                  ></app-value-renderer></span
                ><br />
                <span *ngIf="formulabarData.stats.broker_count !== undefined"
                  ><b>Broker Count</b> =
                  {{ formulabarData.stats.broker_count }}</span
                ><br />
                <span *ngIf="formulabarData.stats.median !== undefined"
                  ><b>Median</b> =
                  <app-value-renderer
                    [value]="formulabarData.stats.median"
                    [precision]="2"
                  ></app-value-renderer></span
                ><br />
                <span
                  *ngIf="formulabarData.stats.consensus_ex_min !== undefined"
                >
                  <span
                    *ngIf="
                      formulabarData.source.toLowerCase() !== 'consensus+' &&
                      formulabarData.rpsource.toLowerCase() !== 'consensus+'
                    "
                  >
                    <b>ConsensusExMin</b> =
                  </span>
                  <span
                    *ngIf="
                      formulabarData.source.toLowerCase() === 'consensus+' ||
                      formulabarData.rpsource.toLowerCase() === 'consensus+'
                    "
                  >
                    <b>Consensus+ExMin</b> =
                  </span>
                  <app-value-renderer
                    [value]="formulabarData.stats.consensus_ex_min"
                    [precision]="2"
                  ></app-value-renderer></span
                ><br />
              </div>

              <div nz-col nzSpan="8">
                <span *ngIf="formulabarData.stats.mn !== undefined"
                  ><b>Min</b> =
                  <app-value-renderer
                    [value]="formulabarData.stats.mn.v"
                    [precision]="2"
                  ></app-value-renderer
                  ><span
                    *ngIf="
                      brokerCountForSellSide === 0 ||
                      formulabarData.stats.mn.sName
                    "
                  >
                    [</span
                  >{{ formulabarData.stats.mn.sName
                  }}<span
                    *ngIf="
                      brokerCountForSellSide === 0 ||
                      formulabarData.stats.mn.sName
                    "
                    >]</span
                  ></span
                ><br />
                <span
                  *ngIf="
                    formulabarData.stats &&
                    formulabarData.stats.broker_count !== undefined
                  "
                  ><b>Standard Deviation</b> =
                  <app-value-renderer
                    [value]="formulabarData.stats.d"
                    [precision]="2"
                  ></app-value-renderer></span
                ><br />
                <span
                  ><b>Range</b> =
                  <app-value-renderer
                    [value]="formulabarData.stats.range"
                    [precision]="2"
                  ></app-value-renderer></span
                ><br />
                <ng-container
                  [ngTemplateOutlet]="consensusExMinExMax"
                  [ngTemplateOutletContext]="{ formulabarData: formulabarData }"
                >
                </ng-container
                ><br />
              </div>

              <div nz-col nzSpan="8">
                <span *ngIf="formulabarData.stats.mx !== undefined"
                  ><b>Max</b> =
                  <app-value-renderer
                    [value]="formulabarData.stats.mx.v"
                    [precision]="2"
                  ></app-value-renderer
                  ><span
                    *ngIf="
                      brokerCountForSellSide === 0 ||
                      formulabarData.stats.mx.sName
                    "
                  >
                    [</span
                  >{{ formulabarData.stats.mx.sName
                  }}<span
                    *ngIf="
                      brokerCountForSellSide === 0 ||
                      formulabarData.stats.mx.sName
                    "
                    >]</span
                  ></span
                ><br />
                <span *ngIf="formulabarData.stats.cv !== undefined"
                  ><b>CV</b> =
                  <app-value-renderer
                    [value]="formulabarData.stats.cv"
                    [precision]="2"
                  ></app-value-renderer>
                  %</span
                ><br />
                <span
                  *ngIf="formulabarData.stats.consensus_ex_max !== undefined"
                >
                  <span
                    *ngIf="
                      formulabarData.source.toLowerCase() !== 'consensus+' &&
                      formulabarData.rpsource.toLowerCase() !== 'consensus+'
                    "
                  >
                    <b>ConsensusExMax</b> =
                  </span>
                  <span
                    *ngIf="
                      formulabarData.source.toLowerCase() === 'consensus+' ||
                      formulabarData.rpsource.toLowerCase() === 'consensus+'
                    "
                  >
                    <b>Consensus+ExMax</b> =
                  </span>
                  <app-value-renderer
                    [value]="formulabarData.stats.consensus_ex_max"
                    [precision]="2"
                  ></app-value-renderer></span
                ><br />
              </div>
              <!-- </div> -->
            </div>
            <!-- VA Actuals stats for Mode - Filings is blank, so no code here-->
          </div>
        </div>

        <!-- SAR Stats like Section -->
        <div
          *ngIf="fbarExpanded && formulabarData.cut === 'SAR'"
          class="fbar-stats-section-sar"
        >
          <div
            *ngIf="
              !formulabarData.formula && formulabarData.nmv_link !== undefined
            "
          >
            <hr />
            <div>
              <b style="font-size: 12px">Direct Mappings</b>
            </div>

            <div
              nz-row
              nzType="flex"
              nzJustify="start"
              nzGutter="20"
              style="margin-bottom: 5px"
            >
              <div nz-col nzSpan="12">
                <b class="datapoint-highlight"
                  ><app-value-renderer
                    [value]="formulabarData.value"
                    [precision]="formulabarData.precision"
                  ></app-value-renderer
                ></b>
              </div>

              <!-- Refactor this object when rewriting from backend -->
              <div
                *ngIf="
                  formulabarData.linkMapping &&
                  formulabarData.linkMapping.CAP.length > 0
                "
              >
                <div nz-col *ngFor="let line of formulabarData.linkMapping.CAP">
                  <ng-template
                    *ngIf="disableAnchorLink"
                    [ngTemplateOutlet]="nmvTooltipTemplate"
                  >
                  </ng-template>
                  <!-- Links here ALWAYS go to NMV -->
                  <a
                    *ngIf="!disableAnchorLink"
                    routerLink="/mex/{{ formulabarData.ticker }}/NMV/{{
                      line.tabSName
                    }}"
                    [queryParams]="{
                      expand_consensus: true,
                      dpid: line.dpid,
                      period: formulabarData.fiscalperiod
                    }"
                    queryParamsHandling="merge"
                    target="_blank"
                    nz-tooltip
                    nzTooltipTitle="Load the {{
                      formulabarData.source
                    }} model view containing {{ line.name }} in a new tab"
                    nzTooltipPlacement="right"
                    nzTooltipMouseEnterDelay="10"
                    [nzTooltipTitleContext]="line"
                    [nzTooltipOverlayStyle]="{
                      fontSize: '11px',
                      padding: '0px',
                      background: '#999'
                    }"
                  >
                    <ng-template [ngTemplateOutlet]="nmvTooltipTemplate">
                    </ng-template>
                  </a>
                  <!--nmv link tooltip template-->
                  <ng-template #nmvTooltipTemplate>
                    <span
                      >[{{ line.tabName }}] {{ line.name }} ({{
                        formulabarData.source
                      }}, {{ formulabarData.period }})
                    </span>
                  </ng-template>
                </div>
              </div>
              <hr />
            </div>

            <div
              *ngIf="
                formulabarData.linkMapping &&
                formulabarData.linkMapping.COM.length > 0
              "
            >
              <hr />
              <div nz-row nzType="flex" nzJustify="start">
                <b style="font-size: 12px">Also Used in These Calculations</b>
              </div>

              <!-- need to change below link as per nmv-links  -->
              <div
                nz-row
                nzType="flex"
                nzJustify="start"
                style="margin-bottom: 5px"
              >
                <div
                  nz-col
                  nzSpan="24"
                  *ngFor="let line of formulabarData.linkMapping.COM"
                >
                  <ng-template
                    *ngIf="disableAnchorLink"
                    [ngTemplateOutlet]="nmvTooltipTemplate2"
                  >
                  </ng-template>
                  <!-- Links here ALWAYS go to NMV -->
                  <a
                    *ngIf="!disableAnchorLink"
                    routerLink="/mex/{{ formulabarData.ticker }}/NMV/{{
                      line.tabSName
                    }}"
                    [queryParams]="{
                      expand_consensus: true,
                      dpid: line.dpid,
                      period: formulabarData.fiscalperiod
                    }"
                    queryParamsHandling="merge"
                    target="_blank"
                    nz-tooltip
                    nzTooltipTitle="Load the {{
                      formulabarData.source
                    }} model view containing {{ line.name }} in a new tab"
                    nzTooltipPlacement="right"
                    nzTooltipMouseEnterDelay="10"
                    [nzTooltipTitleContext]="line"
                    [nzTooltipOverlayStyle]="{
                      fontSize: '11px',
                      padding: '0px',
                      background: '#999'
                    }"
                  >
                    <ng-template [ngTemplateOutlet]="nmvTooltipTemplate2">
                    </ng-template>
                  </a>
                  <!-- Created template here again as #nmvTooltipTemplate (used above) is used inside for loop hence can not re-use here, hence created #nmvTooltipTemplate2 which will also be inside a loop hence seperate templates are needed  -->
                  <ng-template #nmvTooltipTemplate2>
                    <span
                      >[{{ line.tabName }}] {{ line.name }} ({{
                        formulabarData.source
                      }}, {{ formulabarData.period }})
                    </span>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- SAR Stats like Section -->
        <div
          *ngIf="fbarExpanded && formulabarData.cut === 'SAR'"
          class="sar-header"
        >
          <b
            >{{ formulabarData.name }}({{ formulabarData.source }},
            {{ formulabarData.period
            }}<span *ngIf="formulabarData.forecast">E</span>,
            {{ formulabarData.growthtype }})</b
          >
        </div>
      </div>
    </div>
  </div>
</div>
<div id="new-formula-bar-container" *ngIf="showNewFbar">
  <span class="fx" *ngIf="showFx">fx</span>
  <div
    class="fbar-container"
    [ngClass]="openedForAddIn ? 'excel-formulabar' : ''"
    [ngStyle]="
      comparativeAnalysisBorderedFormulaBar
        ? comparativeAnalysisShortFormulaBar
          ? { border: '1px solid #BCC2CC', width: '42vw' }
          : { border: '1px solid #BCC2CC', width: '60vw' }
        : {}
    "
  >
    <va-formula-bar
      *ngIf="isDpCallObjReady"
      [(dpCallObj)]="dpCallObj"
      apiUrl="/api/get_fb"
      [apiEP]="apiEP"
      [showExcelModel]="showExcelModel"
      (onDownloadModel)="downloadModelFromNewFb($event)"
      (onNodeToggle)="logNewFbAction($event)"
    ></va-formula-bar>
  </div>
</div>
<ng-template #formulaTreeTemplate let-node>
  <!-- Expression handling for Root Node -->
  <div class="root-node-container">
    <span class="formulabar-tree-template" *ngIf="node.origin.isRoot">
      <span *ngIf="node.origin.extra.cut !== 'SAR'">
        <!-- Handling for fuzzy header -->
        <span class="fuzzy-color" *ngIf="formulabarData.is_fuzzy === true">
          <b class="fuzzy-line-info"
            >&sim;
            <ng-container
              *ngTemplateOutlet="
                valueRenderer;
                context: { $implicit: node.origin.extra }
              "
            ></ng-container>
            &mdash; {{ node.origin.extra.name }}</b
          >
          <br />
        </span>
        <!-- If Formulabar is not fuzzy -->
        <span *ngIf="!formulabarData.is_fuzzy">
          <b
            ><ng-container
              *ngTemplateOutlet="
                valueRenderer;
                context: { $implicit: node.origin.extra }
              "
            ></ng-container></b
          ><span>&nbsp;=&nbsp;</span>
          <span
            *ngIf="
              node.origin.operator === 'AVG' ||
              node.origin.operator === 'MODE' ||
              node.origin.operator === 'MEAN' ||
              node.origin.operator === 'REVISED_MODE' ||
              node.origin.operator === 'RESTATED'
            "
          >
            <span>{{ node.origin.operator }} (</span
            ><span
              *ngFor="let val of node.origin.brokerValues; let last = last"
            >
              <span *ngIf="node.origin.operator === 'AVG'"
                ><ng-container
                  *ngTemplateOutlet="valueRenderer; context: { $implicit: val }"
                ></ng-container
              ></span>
              <b
                *ngIf="
                  (node.origin.extra.value | number: '1.0-2') ===
                    (val.value | number: '1.0-2') &&
                  (node.origin.operator === 'MODE' ||
                    node.origin.operator === 'MEAN' ||
                    node.origin.operator === 'REVISED_MODE' ||
                    node.origin.operator === 'RESTATED') &&
                  node.origin.operator !== 'AVG'
                "
                ><ng-container
                  *ngTemplateOutlet="valueRenderer; context: { $implicit: val }"
                ></ng-container
              ></b>
              <span
                *ngIf="
                  (node.origin.extra.value | number: '1.0-2') !==
                    (val.value | number: '1.0-2') &&
                  node.origin.operator !== 'AVG'
                "
                ><ng-container
                  *ngTemplateOutlet="valueRenderer; context: { $implicit: val }"
                ></ng-container
              ></span>
              <span *ngIf="!last">, </span>
              <span *ngIf="last && brokerCountForSellSide > 0">
                and {{ brokerCountForSellSide }}
                <span *ngIf="brokerCountForSellSide === 1">other</span>
                <span *ngIf="brokerCountForSellSide > 1">others</span>
              </span>
            </span>
            <span
              *ngIf="
                node.origin.brokerValues.length === 0 &&
                brokerCountForSellSide === 1
              "
              >{{ brokerCountForSellSide }} Source</span
            >
            <span
              *ngIf="
                node.origin.brokerValues.length === 0 &&
                brokerCountForSellSide > 1
              "
              >{{ brokerCountForSellSide }} Sources</span
            >
            )
          </span>

          <span *ngIf="!node.origin.operator">
            <span *ngFor="let val of node.origin.brokerValues; let last = last">
              <ng-container
                *ngTemplateOutlet="valueRenderer; context: { $implicit: val }"
              ></ng-container>
            </span>
          </span>
        </span>

        <span
          *ngIf="
            node.origin.operator !== 'AVG' &&
            node.origin.operator !== 'MODE' &&
            node.origin.operator !== 'MEAN' &&
            node.origin.operator !== 'REVISED_MODE'
          "
          [ngClass]="[formulabarData.is_fuzzy ? 'fuzzy-header-container' : '']"
        >
          <span
            *ngFor="let val of node.origin.generatedExpression; let last = last"
          >
            <span *ngIf="val.cut">
              <ng-container
                *ngTemplateOutlet="valueRenderer; context: { $implicit: val }"
              ></ng-container>
            </span>
            <span *ngIf="!val.cut && !val.type">
              <span
                *ngIf="val.name == 'CONST'"
                nz-tooltip
                nzTooltipTitle="CONST"
                nzTooltipPlacement="bottomLeft"
                nzTooltipMouseEnterDelay="10"
                [nzTooltipOverlayStyle]="{
                  fontSize: '11px',
                  padding: '0px',
                  background: '#999'
                }"
                [nzTooltipTitleContext]="val"
                >{{ val.value }}
              </span>
              <span *ngIf="val.name == 'Exchange Rate'">
                <ng-container
                  *ngTemplateOutlet="valueRenderer; context: { $implicit: val }"
                ></ng-container>
              </span>
              <span
                *ngIf="val.name != 'CONST' && val.name != 'Exchange Rate'"
                >{{ val.value }}</span
              >
            </span>
          </span>
        </span>
      </span>

      <span *ngIf="node.origin.extra.cut === 'SAR'">
        <b
          ><ng-container
            *ngTemplateOutlet="
              valueRenderer;
              context: { $implicit: node.origin.extra }
            "
          ></ng-container
        ></b>
        =
        <span *ngIf="!node.origin.extra.formula"
          ><ng-container
            *ngTemplateOutlet="
              valueRenderer;
              context: { $implicit: node.origin.extra }
            "
          ></ng-container>
        </span>
        <span
          *ngIf="
            node.origin.extra.formula &&
            node.origin.operator !== '/' &&
            node.origin.operator !== '*'
          "
        >
          <span *ngFor="let val of node.origin.brokerValues; let last = last">
            <span *ngIf="!last"
              ><ng-container
                *ngTemplateOutlet="valueRenderer; context: { $implicit: val }"
              ></ng-container
            ></span>
            <span *ngIf="last">
              {{ node.origin.operator }}
              <ng-container
                *ngTemplateOutlet="valueRenderer; context: { $implicit: val }"
              ></ng-container
            ></span>
            <span
              *ngIf="
                last && brokerCountForSellSide && brokerCountForSellSide > 0
              "
            >
              and {{ brokerCountForSellSide }}
              <span *ngIf="brokerCountForSellSide === 1">other</span>
              <span *ngIf="brokerCountForSellSide > 1">others</span>
            </span>
          </span>
        </span>

        <span *ngIf="node.origin.operator === '/'">
          <span>(</span
          ><span *ngFor="let val of node.origin.brokerValues; let last = last">
            <span *ngIf="last"> - </span
            ><ng-container
              *ngTemplateOutlet="valueRenderer; context: { $implicit: val }"
            ></ng-container>
            <span *ngIf="last"
              >){{ node.origin.operator
              }}<ng-container
                *ngTemplateOutlet="valueRenderer; context: { $implicit: val }"
              ></ng-container
            ></span>
          </span>
        </span>

        <span *ngIf="node.origin.operator === '*'">
          <span>(</span
          ><span *ngFor="let val of node.origin.brokerValues; let last = last">
            <span *ngIf="!last"
              ><ng-container
                *ngTemplateOutlet="valueRenderer; context: { $implicit: val }"
              ></ng-container
            ></span>
            <span *ngIf="last"
              >/<ng-container
                *ngTemplateOutlet="valueRenderer; context: { $implicit: val }"
              ></ng-container
              >)*100</span
            >
          </span>
        </span>
      </span>
    </span>

    <span
      *ngIf="
        formulabarData.is_fuzzy === true &&
        node.origin.isRoot &&
        node.origin.operator &&
        (node.origin.operator === 'AVG' ||
          node.origin.operator === 'MODE' ||
          node.origin.operator === 'MEAN' ||
          node.origin.operator === 'REVISED_MODE' ||
          node.origin.operator === 'RESTATED')
      "
      class="fuzzy-margin fuzzy-header-container"
    >
      <span [ngClass]="[fbarExpanded ? 'showFuzzyHeader' : 'hideFuzzyHeader']">
        <b
          ><ng-container
            *ngTemplateOutlet="
              valueRenderer;
              context: { $implicit: node.origin.extra }
            "
          ></ng-container
        ></b>
        = {{ node.origin.operator }}(
        <span *ngFor="let val of node.origin.brokerValues; let last = last">
          <ng-container
            *ngTemplateOutlet="valueRenderer; context: { $implicit: val }"
          ></ng-container>
          <span *ngIf="!last">, </span>
          <span *ngIf="last && val.brokerCount && val.brokerCount > 0">
            and {{ val.brokerCount }}
            <span *ngIf="val.brokerCount === 1">other</span>
            <span *ngIf="val.brokerCount > 1">others</span>
          </span>
        </span>
        <span
          *ngIf="
            node.origin.brokerValues.length === 0 && brokerCountForSellSide > 0
          "
          >{{ brokerCountForSellSide }}
          <span *ngIf="brokerCountForSellSide === 1"> Source</span>
          <span *ngIf="brokerCountForSellSide > 1"> Sources</span> </span
        >)</span
      >
    </span>
  </div>

  <!-- Expression handling for Child Node -->
  <div
    class="child-node-cotainer display-flex tree-poc-node"
    *ngIf="node.origin.isChild"
  >
    <!-- Child left hand side expression -->
    <span
      [ngClass]="[
        (node.origin.extra.annotation &&
          node.origin.extra.annotation.charAt(0) > 0 &&
          node.origin.isInferred) ||
        node.origin.isInferred
          ? 'child-expr-details inferred-data'
          : 'child-expr-details'
      ]"
      ><b
        ><ng-container
          *ngTemplateOutlet="
            valueRenderer;
            context: { $implicit: node.origin.extra }
          "
        ></ng-container
      ></b>

      <span *ngIf="node.origin.extra.cut !== 'SAR'">
        =
        <span
          *ngIf="
            node.origin.operator === 'AVG' ||
            node.origin.operator === 'MODE' ||
            node.origin.operator === 'MEAN' ||
            node.origin.operator === 'REVISED_MODE' ||
            node.origin.operator === 'RESTATED'
          "
        >
          <span *ngIf="node.origin.operator"
            >{{ node.origin.operator }} (<span
              *ngFor="let val of node.origin.brokerValues; let last = last"
            >
              <span *ngIf="node.origin.operator === 'AVG'">
                <ng-container
                  *ngTemplateOutlet="valueRenderer; context: { $implicit: val }"
                ></ng-container
              ></span>

              <b
                *ngIf="
                  (node.origin.extra.value | number: '1.0-2') ===
                    (val.value | number: '1.0-2') &&
                  (node.origin.operator === 'MODE' ||
                    node.origin.operator === 'MEAN' ||
                    node.origin.operator === 'REVISED_MODE' ||
                    node.origin.operator === 'RESTATED') &&
                  node.origin.operator !== 'AVG'
                "
                ><ng-container
                  *ngTemplateOutlet="valueRenderer; context: { $implicit: val }"
                ></ng-container
              ></b>
              <span
                *ngIf="
                  (node.origin.extra.value | number: '1.0-2') !==
                    (val.value | number: '1.0-2') &&
                  node.origin.operator !== 'AVG'
                "
                ><ng-container
                  *ngTemplateOutlet="valueRenderer; context: { $implicit: val }"
                ></ng-container
              ></span>
              <span *ngIf="!last">, </span>
              <span *ngIf="last && val.brokerCount && val.brokerCount > 0">
                and {{ val.brokerCount }}
                <span *ngIf="val.brokerCount === 1">other</span
                ><span *ngIf="val.brokerCount > 1">others</span>
              </span>
            </span>
            <span
              *ngIf="
                node.origin.brokerValues.length === 0 &&
                brokerCountForSellSide &&
                node.origin.brokerCountForSellSide
              "
              >{{ node.origin.brokerCountForSellSide }}
              <span *ngIf="node.origin.brokerCountForSellSide === 1"
                >Source</span
              >
              <span *ngIf="node.origin.brokerCountForSellSide > 1"
                >Sources</span
              ></span
            >)
          </span>
        </span>

        <span
          *ngIf="
            node.origin.operator &&
            node.origin.operator !== 'AVG' &&
            node.origin.operator !== 'MODE' &&
            node.origin.operator !== 'MEAN' &&
            node.origin.operator !== 'REVISED_MODE'
          "
        >
          <span
            *ngFor="let val of node.origin.generatedExpression; let last = last"
          >
            <span *ngIf="val.cut">
              <ng-container
                *ngTemplateOutlet="valueRenderer; context: { $implicit: val }"
              ></ng-container>
            </span>
            <span *ngIf="!val.cut && !val.type">
              <span
                *ngIf="val.name == 'CONST'"
                nz-tooltip
                nzTooltipTitle="CONST"
                nzTooltipPlacement="bottomLeft"
                nzTooltipMouseEnterDelay="10"
                [nzTooltipOverlayStyle]="{
                  fontSize: '11px',
                  padding: '0px',
                  background: '#999'
                }"
                [nzTooltipTitleContext]="val"
                >{{ val.value }}</span
              >
              <span *ngIf="val.name == 'Exchange Rate'">
                <ng-container
                  *ngTemplateOutlet="valueRenderer; context: { $implicit: val }"
                ></ng-container>
              </span>
              <span
                *ngIf="val.name != 'CONST' && val.name != 'Exchange Rate'"
                >{{ val.value }}</span
              >
            </span>
          </span>
        </span>

        <span
          *ngIf="
            !node.origin.operator &&
            !node.origin.extra.fromOpd &&
            !node.origin.extra.expresssion_error
          "
        >
          <ng-container *ngIf="node.origin.extra.formula">
            <ng-container
              *ngTemplateOutlet="
                valueRenderer;
                context: { $implicit: node.origin.extra.formula }
              "
            ></ng-container>
          </ng-container>

          <!-- Fix for CACC-5005-->
          <ng-container
            *ngIf="
              !node.origin.extra.formula && node.origin.extra.cut === 'REF'
            "
          >
            <ng-container
              *ngTemplateOutlet="
                valueRenderer;
                context: { $implicit: node.origin.extra }
              "
            ></ng-container>
          </ng-container>
        </span>

        <span
          *ngIf="
            !node.origin.operator &&
            !node.origin.extra.fromOpd &&
            node.origin.extra.expresssion_error
          "
        >
          Expression Not Available
        </span>

        <span *ngIf="!node.origin.operator && node.origin.extra.fromOpd">
          <ng-container
            *ngTemplateOutlet="
              valueRenderer;
              context: { $implicit: node.origin.extra }
            "
          >
          </ng-container>
        </span>
      </span>
    </span>

    <!-- Child right hand side text -->
    <span
      *ngIf="node.origin.isChild && node.origin.extra.cut !== 'SAR'"
      [ngClass]="[
        (node.origin.extra.annotation &&
          node.origin.extra.annotation.charAt(0) > 0 &&
          node.origin.isInferred) ||
        node.origin.isInferred
          ? 'child-line-details  inferred-data'
          : 'child-line-details'
      ]"
    >
      <span
        nz-tooltip
        [nzTooltipTitle]="parentExpressionLinkTooltip"
        [nzTooltipTitleContext]="node"
        nzTooltipPlacement="top"
      >
        <!-- if price node with exchange info, then show this else show default info -->
        <span
          *ngIf="
            node.origin.extra.cut === 'REF' &&
              targetPriceDp.includes(node.origin.extra.dp);
            else defaultChildLabel
          "
        >
          {{ node.origin.extra.exchange_info }}
        </span>
        <ng-template #defaultChildLabel>
          {{ node.origin.extra.name }}
          <span *ngIf="node.origin.extra.display_magnitude"
            >({{ node.origin.extra.display_magnitude }})</span
          >
        </ng-template>
        [{{ node.origin.extra.source
        }}{{ node.origin.extra.source !== "" ? ", " : ""
        }}{{ node.origin.extra.period
        }}<span *ngIf="node.origin.extra.forecast">E</span>
        <span
          class="inferred-background"
          *ngIf="
            node.origin.extra.annotation &&
            node.origin.extra.annotation.charAt(0) > 0 &&
            fiscalSources.includes(formulabarData.source.toLowerCase())
          "
          >,Inferred</span
        >
        <span *ngIf="node.origin.extra.modeldate"
          >,{{ node.origin.extra.modeldate }}</span
        ><span
          *ngIf="
            node.origin.extra.analyst && node.origin.extra.analyst.length > 0
          "
          >,{{ node.origin.extra.analyst }}</span
        >]
        {{
          node.origin.extra.reverse_adjust_message
            ? "(" + node.origin.extra.reverse_adjust_message + ")"
            : ""
        }}
        <ng-template #parentExpressionLinkTooltip>
          <span
            *ngIf="
              node.origin.extra.cut === 'REF' &&
                targetPriceDp.includes(node.origin.extra.dp);
              else defaultChildLabel
            "
          >
            {{ node.origin.extra.exchange_info }}
          </span>
          [{{ node.origin.extra.source
          }}{{ node.origin.extra.source !== "" ? ", " : ""
          }}{{ node.origin.extra.period
          }}<span *ngIf="node.origin.extra.forecast">E</span>
          <span
            *ngIf="
              node.origin.extra.annotation &&
              node.origin.extra.annotation.charAt(0) > 0 &&
              fiscalSources.includes(formulabarData.source.toLowerCase())
            "
            >,Inferred</span
          >
          <span *ngIf="node.origin.extra.modeldate"
            >,{{ node.origin.extra.modeldate }}</span
          ><span
            *ngIf="
              node.origin.extra.analyst && node.origin.extra.analyst.length > 0
            "
            >,{{ node.origin.extra.analyst }}</span
          >]
          {{
            node.origin.extra.reverse_adjust_message
              ? "(" + node.origin.extra.reverse_adjust_message + ")"
              : ""
          }}
        </ng-template>
      </span>
    </span>

    <!-- Child right hand side LINK for SAR -->
    <span
      *ngIf="node.origin.isChild && node.origin.extra.cut === 'SAR'"
      [ngClass]="[
        (node.origin.extra.annotation &&
          node.origin.extra.annotation.charAt(0) > 0 &&
          node.origin.isInferred) ||
        node.origin.isInferred
          ? 'child-line-details  inferred-data'
          : 'child-line-details'
      ]"
    >
      <span *ngIf="node.origin.extra.source !== 'Filings'">
        <a
          nz-tooltip
          [ngClass]="[disableAnchorLink ? 'dumb-anchor-tag' : '']"
          [nzTooltipTitle]="
            disableAnchorLink ? null : childExpressionLinkTooltip
          "
          [nzTooltipTitleContext]="node"
          nzTooltipPlacement="bottom"
          [nzTooltipOverlayStyle]="{
            fontSize: '11px',
            padding: '0px',
            background: '#999',
            maxWidth: '400px'
          }"
          (click)="loadViewinNewTab($event, node.origin.extra)"
        >
          {{ node.origin.extra.name }}
          <span *ngIf="node.origin.extra.display_magnitude"
            >({{ formulabarData.display_magnitude }})</span
          >
          [<span *ngIf="node.origin.extra.source">{{
            node.origin.extra.source
          }}</span>
          <span *ngIf="node.origin.extra.period"
            >, {{ node.origin.extra.period
            }}<span *ngIf="node.origin.extra.forecast">E</span></span
          >
          <span *ngIf="node.origin.extra.modeldate"
            >, {{ node.origin.extra.modeldate }}</span
          >
          <span
            *ngIf="
              node.origin.extra.analyst && node.origin.extra.analyst.length > 0
            "
            >, {{ node.origin.extra.analyst }}</span
          >]
          <!--Child rhs link tooltip template-->
          <ng-template #childExpressionLinkTooltip>
            <span
              *ngIf="
                node.origin.popOverText && node.origin.popOverText.length > 70
              "
              >{{ node.origin.popOverText }},
            </span>
            <span
              >Load the {{ node.origin.extra.source }} model view containing
              {{ node.origin.extra.name }} in a new tab</span
            >
          </ng-template>
        </a>
      </span>

      <!-- for filings -->
      <span *ngIf="node.origin.extra.source === 'Filings'">
        <span
          nz-tooltip
          [nzTooltipTitle]="fillingsTooltip"
          [nzTooltipTitleContext]="node"
          nzTooltipPlacement="top"
        >
          {{ node.origin.extra.name }}[{{ node.origin.extra.source }},
          {{ node.origin.extra.period }}, {{ node.origin.extra.modeldate }}]
        </span>
      </span>
      <ng-template #fillingsTooltip>
        <span
          >{{ node.origin.extra.name }}[{{ node.origin.extra.source }},
          {{ node.origin.extra.period }},
          {{ node.origin.extra.modeldate }}]</span
        >
      </ng-template>
    </span>
  </div>

  <!-- Expression handling for Leaf Node -->
  <div class="leaf-node" *ngIf="node.isLeaf">
    <div class="display-flex" *ngIf="node.origin.extra.expresssion_error">
      <span
        [ngClass]="[
          (node.origin.extra.annotation &&
            node.origin.extra.annotation.charAt(0) > 0 &&
            node.origin.isInferred) ||
          node.origin.isInferred
            ? 'child-expr-details inferred-data'
            : 'child-expr-details'
        ]"
        ><b
          ><ng-container
            *ngTemplateOutlet="
              valueRenderer;
              context: { $implicit: node.origin.extra }
            "
          ></ng-container
        ></b>
        = Expression Not Available</span
      >
      <span
        [ngClass]="[
          (node.origin.extra.annotation &&
            node.origin.extra.annotation.charAt(0) > 0 &&
            node.origin.isInferred) ||
          node.origin.isInferred
            ? 'child-line-details  inferred-data'
            : 'child-line-details'
        ]"
      >
        <span
          nz-tooltip
          [nzTooltipTitle]="subChildExpressionLinkTooltip"
          [nzTooltipTitleContext]="node"
          nzTooltipPlacement="top"
        >
          {{ node.origin.extra.name }}
          <span *ngIf="node.origin.extra.display_magnitude"
            >({{ node.origin.extra.display_magnitude }})</span
          >
          [{{ node.origin.extra.source }},{{ node.origin.extra.period
          }}<span *ngIf="node.origin.extra.forecast">E</span>
          <span *ngIf="node.origin.extra.modeldate"
            >,{{ node.origin.extra.modeldate }}</span
          ><span
            *ngIf="
              node.origin.extra.analyst && node.origin.extra.analyst.length > 0
            "
            >,{{ node.origin.extra.analyst }}</span
          >]
        </span>
      </span>
      <ng-template #subChildExpressionLinkTooltip>
        {{ node.origin.extra.name }}
        <span *ngIf="node.origin.extra.display_magnitude"
          >({{ node.origin.extra.display_magnitude }})</span
        >
        [{{ node.origin.extra.source
        }}{{ node.origin.extra.source !== "" ? ", " : ""
        }}{{ node.origin.extra.period
        }}<span *ngIf="node.origin.extra.forecast">E</span>
        <span
          *ngIf="
            node.origin.extra.annotation &&
            node.origin.extra.annotation.charAt(0) > 0 &&
            fiscalSources.includes(formulabarData.source.toLowerCase())
          "
          >,Inferred</span
        >
        <span *ngIf="node.origin.extra.modeldate"
          >,{{ node.origin.extra.modeldate }}</span
        ><span
          *ngIf="
            node.origin.extra.analyst && node.origin.extra.analyst.length > 0
          "
          >,{{ node.origin.extra.analyst }}</span
        >]
      </ng-template>
    </div>

    <div
      *ngIf="
        !node.origin.extra.expresssion_error && node.origin.extra.cut === 'SAR'
      "
      class="remove-switcher-icon"
    >
      <span *ngIf="node.origin.extra.source !== 'Filings'">
        [{{ node.origin.extra.source }}
        <span
          *ngIf="
            node.origin.extra.analyst && node.origin.extra.analyst.length > 0
          "
          >, {{ node.origin.extra.analyst }}</span
        >
        <span *ngIf="node.origin.extra.documentDate"
          >, {{ node.origin.extra.documentDate }}</span
        >
        <span *ngIf="node.origin.extra.sheetName"
          >, Sheet : {{ node.origin.extra.sheetName }}</span
        >
        <span *ngIf="node.origin.extra.cellRef"
          >, Cell : {{ node.origin.extra.cellRef }}
        </span>
        <va-icon
          nz-tooltip
          nzTooltipTitle="Download Model"
          nzTooltipPlacement="bottom"
          [nzTooltipOverlayStyle]="{
            fontSize: '11px',
            padding: '0px',
            background: '#999'
          }"
          (click)="downloadModel(node.origin.extra)"
          size="small"
          name="file-excel"
          class="file-icon"
        >
        </va-icon
        >]
      </span>

      <span *ngIf="node.origin.extra.source === 'Filings'">
        [{{ node.origin.extra.source }}, {{ node.origin.extra.documentDate }}
        <va-icon
          nz-tooltip
          nzTooltipTitle="Show Filings"
          nzTooltipPlacement="bottom"
          [nzTooltipOverlayStyle]="{
            fontSize: '11px',
            padding: '0px',
            background: '#999'
          }"
          (click)="downloadModel(node.origin.extra)"
          size="small"
          name="file-excel"
          class="file-icon"
        >
        </va-icon
        >]
      </span>
    </div>

    <!-- for currency node -->
    <div
      *ngIf="
        !node.origin.extra.expresssion_error && node.origin.extra.exchange_info
      "
      class="display-flex"
    >
      <span class="child-expr-details"
        ><b
          ><ng-container
            *ngTemplateOutlet="
              valueRenderer;
              context: { $implicit: node.origin.extra }
            "
          ></ng-container
        ></b>
        =
        <ng-container
          *ngTemplateOutlet="
            valueRenderer;
            context: { $implicit: node.origin.extra }
          "
        ></ng-container
      ></span>

      <!-- if target price is leaf node, show source, model and analyst detailss-->
      <span
        *ngIf="
          node.origin.extra.cut === 'REF' &&
            targetPriceDp.includes(node.origin.extra.dp);
          else defuaultLeafHavingExchangeInfo
        "
        class="child-line-details"
        nz-tooltip
        [nzTooltipTitle]="nameMagnitudeSourceModelAnalyst"
        nzTooltipPlacement="top"
        [nzTooltipTitleContext]="node"
      >
        <ng-container
          *ngTemplateOutlet="nameMagnitudeSourceModelAnalyst"
        ></ng-container>
      </span>
    </div>
    <!-- default leaf node with exchange info details-->
    <ng-template #defuaultLeafHavingExchangeInfo>
      <span
        class="child-line-details"
        nz-tooltip
        [nzTooltipTitle]="currencyNodeTooltip"
        nzTooltipPlacement="top"
        [nzTooltipTitleContext]="node"
      >
        {{ node.origin.extra.exchange_info }} [{{
          node.origin.extra.modeldate
        }}]
        {{
          node.origin.extra.reverse_adjust_message
            ? "(" + node.origin.extra.reverse_adjust_message + ")"
            : ""
        }}
      </span></ng-template
    >

    <ng-template #currencyNodeTooltip>
      {{ node.origin.extra.exchange_info }} [{{ node.origin.extra.modeldate }}]
      {{
        node.origin.extra.reverse_adjust_message
          ? "(" + node.origin.extra.reverse_adjust_message + ")"
          : ""
      }}
    </ng-template>
    <ng-template #nameMagnitudeSourceModelAnalyst>
      {{ node.origin.extra.exchange_info }}
      [<span *ngIf="node.origin.extra.source">{{
        node.origin.extra.source
      }}</span>
      <span *ngIf="node.origin.extra.modeldate"
        >, {{ node.origin.extra.modeldate }}</span
      >
      <span
        *ngIf="
          node.origin.extra.analyst && node.origin.extra.analyst.length > 0
        "
        >, {{ node.origin.extra.analyst }}</span
      >]
    </ng-template>

    <!-- If user doesn't have access to any of the brokers don't show expand icon -->
    <span
      *ngIf="
        node.origin.brokerValues &&
        node.origin.brokerValues.length === 0 &&
        brokerCountForSellSide > 0
      "
    >
      <span class="child-expr-details">
        <b
          ><ng-container
            *ngTemplateOutlet="
              valueRenderer;
              context: { $implicit: node.origin.extra }
            "
          ></ng-container
        ></b>
        <span *ngIf="node.origin.extra.cut !== 'SAR'">
          =
          <span
            *ngIf="
              node.origin.operator === 'AVG' ||
              node.origin.operator === 'MODE' ||
              node.origin.operator === 'MEAN' ||
              node.origin.operator === 'REVISED_MODE'
            "
          >
            <span *ngIf="node.origin.operator"
              >{{ node.origin.operator }} (
              <span
                *ngIf="
                  node.origin.brokerValues.length === 0 &&
                  brokerCountForSellSide > 0
                "
                >{{ brokerCountForSellSide }}
                <span *ngIf="brokerCountForSellSide === 1">Source</span>
                <span *ngIf="brokerCountForSellSide > 1">Sources</span></span
              >
              )
            </span>
          </span>
        </span>
      </span>
    </span>
  </div>
</ng-template>

<!-- custom icon template -->
<ng-template #doubleArrowExpandIcon let-node>
  <i *ngIf="node.origin.isRoot && !node.origin.extra.expand_disabled">
    <va-icon
      class="ant-tree-switcher-icon"
      [ngClass]="{ 'dbl-arrow': true, 'dbl-arrow-expanded': fbarExpanded }"
      size="small"
      name="double-arrow-right"
      style="font-size: 11px"
    ></va-icon>
  </i>
  <i *ngIf="node.origin.isChild">
    <va-icon
      class="ant-tree-switcher-icon"
      size="small"
      name="caret-right"
      style="padding-top: 2px"
    >
    </va-icon>
  </i>
</ng-template>

<!-- value rendering template -->
<ng-template #valueRenderer let-node>
  <span
    class="test"
    *ngIf="node !== undefined"
    nz-tooltip
    [nzTooltipTitle]="dataInfoTooltip"
    [nzTooltipTitleContext]="node"
    nzTooltipPlacement="bottomLeft"
    [nzTooltipOverlayStyle]="{
      fontSize: '11px',
      padding: '0px',
      background: '#999'
    }"
  >
    <app-value-renderer
      [value]="node.value"
      [precision]="
        node.cut === 'REF' || (node.dp && node.dp.toString().startsWith('REF'))
          ? 2
          : node.exchange_info || node.isConst
            ? 4
            : node.precision
      "
      [cut]="node.cut"
      [unit]="node.unit"
      [isInferred]="node.annotation"
    >
    </app-value-renderer>
  </span>
  <ng-template #dataInfoTooltip>
    {{ node.name }}<br />
    <span
      ><span *ngIf="node.period">{{ node.period }}</span
      ><span *ngIf="node.period && node.source">, </span
      ><span *ngIf="node.source">{{ node.source }}</span></span
    >
  </ng-template>
</ng-template>
<!-- <nz-modal
  [(nzVisible)]="isViewModalVisible"
  [nzFooter]="null"
  nzWidth="800px"
  (nzOnCancel)="handleCancel()"
  [nzTitle]="filingsHeading"
  nzClassName="formulabar-filings-modal"
>
  <ng-container *nzModalContent>
    <div class="pagination-bar">
      <div class="doc-details">
        <div class="doc-type">
          <div class="detail-title">Document Type:</div>
          <div class="detail-value">{{ documentType }}</div>
        </div>
        <div class="date-pub">
          <div class="detail-title">Date Published:</div>
          <div class="detail-value">{{ datePublish }}</div>
        </div>
      </div>
      <div class="guidance-navigation" *ngIf="hasGuidance">
        <div class="guidance-title">
          <va-icon
            [name]="'guidance'"
            size="medium"
            class="data-setting-icon guidance-icon"
          ></va-icon>
          Guidance
        </div>
        <div class="guidance-navigator">
          <va-icon
            [name]="'chevron-left'"
            class="data-setting-icon navigator-element"
            size="small"
            (click)="onPrevGuidance()"
          ></va-icon>
          <div class="guidance-index">
            {{ currentGuidance }}
          </div>
          <div class="navigator-element">/</div>
          <div class="guidance-count navigator-element">
            {{ guidanceCount }}
          </div>
          <va-icon
            [name]="'chevron-right'"
            class="data-setting-icon navigator-element"
            size="small"
            (click)="onNextGuidance()"
          ></va-icon>
        </div>
      </div>
    </div>
    <iframe
      id="filingsFrame"
      frameborder="0"
      allowfullscreen
      width="100%"
      height="500px"
      *ngIf="!filingsError"
    ></iframe>
    <div id="filings-error" class="error-container" *ngIf="filingsError">
      <div class="error-msg">
        <va-icon size="small" name="info-circle" class="info-icon"></va-icon>
        <span class="error-text">Filings not found</span>
      </div>
    </div>
  </ng-container>
</nz-modal> -->

<ng-template #consensusExMinExMax let-formulabarData="formulabarData">
  <span *ngIf="formulabarData.stats.consensus_ex_min_ex_max !== undefined">
    <span
      *ngIf="
        formulabarData.source.toLowerCase() !== 'consensus+' &&
        formulabarData.rpsource.toLowerCase() !== 'consensus+'
      "
    >
      <b>ConsensusExMinExMax</b> =
    </span>
    <span
      *ngIf="
        formulabarData.source.toLowerCase() === 'consensus+' ||
        formulabarData.rpsource.toLowerCase() === 'consensus+'
      "
    >
      <b>Consensus+ExMinExMax</b> =
    </span>
    <app-value-renderer
      [value]="formulabarData.stats.consensus_ex_min_ex_max"
      [precision]="2"
    ></app-value-renderer
  ></span>
</ng-template>
